module.exports = __webpack_public_path__ + "static/media/dungeon_floor_ew.241d9b2e.png";